import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);


//Scrolling Behavior Handler
const scrollHandler = function(to, from, savedPosition) {
    
    if( ! savedPosition ) {
        document.getElementById('header').scrollTop = 0;
    }

    return (savedPosition) ? savedPosition : { x: 0, y: 0 };
};

//
const router = new VueRouter({
    mode: 'history',
    scrollBehavior: scrollHandler,
    routes: [

        /*********************************************
        * Home
        *********************************************/
        { path: '/', name: 'Home', component: () => import('./pages/Home.vue') },


        /*********************************************
        * Search Results
        *********************************************/
        { path: '/search', name: 'Search', component: () => import('./pages/Deals.vue') },


        /*********************************************
        * tags
        *********************************************/
        { path: '/tags/:tag', name: 'Tag', component: () => import('./pages/Deals.vue') },


        /*********************************************
        * brands
        *********************************************/
        { path: '/brands/:brand', name: 'Brand', component: () => import('./pages/Deals.vue') },
        { path: '/brands/:brand/:tag', name: 'BrandWithTag', component: () => import('./pages/Deals.vue') },

        /*********************************************
        * stores
        *********************************************/
        { path: '/stores/:store', name: 'Store', component: () => import('./pages/Deals.vue') },

        /*********************************************
        * all deals
        *********************************************/
        { path: '/all', name: 'All', component: () => import('./pages/Deals.vue') },

        /*********************************************
        * Single Deal
        *********************************************/
        { path: '/deal/:dealId', name: 'Deal', component: () => import('./pages/Deal.vue') },


        /*********************************************
        * misc
        *********************************************/
        { path: '/about-us', name: 'AboutUs', component: () => import('./pages/AboutUs.vue') },
        { path: '/contact-us', name: 'ContactUs', component: () => import('./pages/ContactUs.vue') },
        { path: '/privacy-policy', name: 'PrivacyPolicy', component: () => import('./pages/PrivacyPolicy.vue') },
        { path: '/terms-and-conditions', name: 'Terms', component: () => import('./pages/TermsAndConditions.vue') }

    ],
});


//
export default router;